// Our Components
import PageHeading from 'components/PageHeading/PageHeading';
import PylonBorrowerDashboard from 'components/Pylon/PylonBorrowerDashboard';

function PylonBorrowerDashboardPage() {
	return (
		<>
			<PageHeading
				title="Pylon Borrower Dashboard"
				subtitleText="Please select a client to view a loan application status"
			/>

			<PylonBorrowerDashboard />
		</>
	);
}

export default PylonBorrowerDashboardPage;
